import { useMemo } from 'react';

import { useValidationSchemas, type ValidationSchemaKey } from '@/modules/validators';
import { useGetQuoteCargoTypesList } from '@/views/screens/Quote/hooks';

export const useGetRateSchemaCargoTypeOptions = () => {
  const GET_RATE_SCHEMA_KEY = 'GetRatesQuoteRateCriteria';

  const { data: schemas, isLoading: schemasLoading } = useValidationSchemas();
  const { data: allCargoTypes, isLoading: cargoTypesLoading } = useGetQuoteCargoTypesList();

  const schemaCargoTypes = useMemo(() => {
    if (!schemas) {
      return [];
    }

    const schemaKeys = Object.keys(schemas) as ValidationSchemaKey[];

    return schemaKeys
      .filter((value) => value.includes(GET_RATE_SCHEMA_KEY))
      .map((value) => schemas[value]?.lookupCodeId?.trim());
  }, [schemas]);

  const options = useMemo(
    () => allCargoTypes?.filter((option) => schemaCargoTypes.includes(option.value)),
    [allCargoTypes, schemaCargoTypes],
  );

  return { data: options, isLoading: schemasLoading || cargoTypesLoading };
};
